import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class OrdersPackagingRemainingApiService extends ApiService {
  static endpoint = 'stores/orders-packaging/remaining';

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
